
















import { Component, Prop, Vue } from 'vue-property-decorator'
import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
@Component({
    components: { BaseButton },
})
export default class ErrorHandlerItem extends Vue {
    @Prop({ type: Object, required: true }) item!: NotificationOptions

    get error(): Error {
        return this.item.data && this.item.data.error
    }

    get tip(): string {
        return this.item.data && this.item.data.tip
    }
}
